import * as React from 'react'
import Stack from '@mui/material/Stack'
import { Field } from 'formik'
import { MuiCheckboxFormik } from '@user/components/Formik'
import { useData } from '../hooks'

export function SetAsExpectedClosingDateCheckbox() {
  const { dueDateValid } = useData()
  return (
    <Stack spacing={0} mt={-1}>
      <Field
        component={MuiCheckboxFormik}
        disabled={!dueDateValid}
        inputProps={{ p: 0 }}
        label="Set as Expected Closing Date"
        labelProps={{ mb: 0 }}
        name="setDueDateAsExpectedClosingDate"
        size="small"
        color="primary"
        spacing="small"
        data-test-id={`activity-form-set-as-expected-closing-date-checkbox`}
      />
    </Stack>
  )
}
